import { Form } from "@minervaproject/fds";
import React from "react";
import { useSelector } from "react-redux";

import { LoginStore } from "../../store/login";

import { EmailInput } from "./email_input";
import { ErrorMessage } from "./error_message";
import { OrgWrapper } from "./org_wrapper";
import { Paragraph } from "./paragraph";
import { SubmitButton } from "./submit_button";
import { SuccessMessage } from "./success_message";
import { Title } from "./title";

const SendEmailPage = ({
  autoComplete = "chrome-off",
  onSubmitAfter,
  onSubmitBefore,
  submitTextAfter,
  submitTextBefore,
  textAfter,
  textBefore,
  titleAfter,
  titleBefore,
}) => {
  const { data, loading, error } = useSelector(LoginStore.sliceSelectors.select());
  const { contextualMessage, email, successMessage } = data;

  const isAfterSendingEmail = !!contextualMessage;
  const showEmailInput = !isAfterSendingEmail;
  const onSubmit = isAfterSendingEmail ? onSubmitAfter : onSubmitBefore;
  const submitText = isAfterSendingEmail ? submitTextAfter : submitTextBefore;
  const text = isAfterSendingEmail ? textAfter || contextualMessage : textBefore;
  const title = isAfterSendingEmail ? titleAfter : titleBefore;
  const defaultValues = { realemail: email };

  return (
    <OrgWrapper>
      <div className="mb6">
        <Title text={title} />
        <Paragraph text={text} />
        <Form onSubmit={onSubmit} autoComplete={autoComplete} defaultValues={defaultValues}>
          {showEmailInput ? <EmailInput /> : null}
          <SubmitButton loading={loading} text={submitText} />
          {successMessage ? <SuccessMessage msg={successMessage} /> : null}
          {error ? <ErrorMessage msg={error} /> : null}
        </Form>
      </div>
    </OrgWrapper>
  );
};

export { SendEmailPage };
